import { observer } from 'mobx-react-lite';
import { lazy, Suspense } from 'react';

import { Icons } from '@/assets/icons/icons';
import { Button } from '@/components/ui/Button';
import { Popover } from '@/components/ui/popover';

import { getFeatureFlagOverrideCount } from './feature-flags';
import { PluginFlagList } from './plugin-flag-list';

// Dev builds only: Vite drops this import from a packaged build, so the full flag panel never ships
const FeatureFlagDebugger = import.meta.env.DEV
  ? lazy(() =>
      import('./feature-flag-debugger').then((module) => ({
        default: module.FeatureFlagDebugger,
      }))
    )
  : null;

/** Sits beside the chat mode selector and shares its internal-only gate. Dev builds open every flag, released builds the plugin list */
export const FlagsButton = observer(() => {
  const overrideCount = getFeatureFlagOverrideCount();

  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <Button size="dense" variant="secondary" className="gap-1.5 text-xs">
          <Icons.flag className="size-3" aria-hidden="true" />
          {FeatureFlagDebugger ? 'Flags' : 'Plugins'}
          {overrideCount > 0 && (
            <span className="tabular-nums text-foreground-muted">
              {overrideCount}
            </span>
          )}
        </Button>
      </Popover.Trigger>
      <Popover.Content align="end" className="mt-1 w-80 p-0 text-xs">
        {FeatureFlagDebugger ? (
          <Suspense fallback={null}>
            <FeatureFlagDebugger />
          </Suspense>
        ) : (
          <PluginFlagList />
        )}
      </Popover.Content>
    </Popover.Root>
  );
});
